export default [
    {
        show(row) {
            return (
                row.shbj === '0'
            )
        },
        type: 'info',
        text(row) {
            return `待提交`;
        }
    }, {
        show(row) {
            return (
                row.shbj === '1'
            )
        },
        type: 'primary',
        text(row) {
            return `已提交`;
        }
    },

    {
        show(row) {
            return (
                row.shbj === '3'
            )
        },
        type: 'danger',
        text(row) {
            return `已退回`;
        }
    },

    {
        show(row) {
            return (
                row.shbj === '9'
            )
        },
        type: 'success',
        text(row) {
            return `已发布`;
        }
    }
]
